import { IStreamData } from "@formant/core/model/IStreamData";
import { StreamType } from "@formant/core/model/StreamType";

import { IMetadataDataPoint } from "./IMetadataDataPoint";

export function flattenPoints<T extends StreamType>(
    datas: IStreamData<T>[],
): IMetadataDataPoint<T>[] {
    return datas
        .reduce<IMetadataDataPoint<T>[]>(
            (acc, { deviceId, name, type, tags, points }) =>
                acc.concat(
                    points.map(([timestamp, value]) => ({
                        deviceId,
                        name,
                        type,
                        tags,
                        time: new Date(timestamp),
                        value,
                    })),
                ),
            [],
        )
        .sort((a, b) => a.time.getTime() - b.time.getTime());
}
